import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { COMMUNICATION_UI_HIDDEN } from "@/config/communication-availability";

export function CommunicationRoute({ children }: { children: ReactNode }) {
  if (COMMUNICATION_UI_HIDDEN) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
